import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const WORKSHOP_TYPES = [
  { id: 'talenten', label: 'Talentenworkshop', icon: 'Star' },
  { id: 'insights', label: 'Insights Discovery', icon: 'PieChart' },
  { id: 'game', label: 'Game-based Talentenworkshop', icon: 'Target' },
  { id: 'overige', label: 'Overige / Specifiek', icon: 'MoreHorizontal' },
];

const LANGUAGES = [
  { id: 'nl', label: 'Nederlands', sub: 'Standaard' },
  { id: 'bilingual', label: 'Tweetalig', sub: 'NL/FR (+€200)' },
  { id: 'fr', label: 'Frans', sub: '(+€200)' },
  { id: 'en', label: 'Engels', sub: '(+€200)' },
];

export default function StepType({ data, updateData, onNext }) {
  const isValid = data.type && data.pax > 0 && data.language;
  const showInfoTip = data.pax > 20;

  return (
    <div className="space-y-8 animate-fadeIn">
      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-4 text-left">1. Welk type workshop zoekt u?</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {WORKSHOP_TYPES.map((type) => (
            <button
              key={type.id}
              onClick={() => {
                updateData({ type: type.id, duration: '' });
              }}
              className={`p-4 rounded-xl border-2 text-left transition-all flex items-center gap-3 ${
                data.type === type.id
                  ? 'border-[#154A48] bg-white text-[#154A48]'
                  : 'border-gray-200 hover:border-[#154A48]/30 hover:bg-gray-50'
              }`}
            >
              <div className={`p-2 rounded-full ${data.type === type.id ? 'bg-[#154A48] text-white' : 'bg-gray-100 text-gray-500'}`}>
                <SafeIcon name={type.icon} className="text-xl" />
              </div>
              <span className="font-medium">{type.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-4 text-left">2. Wat is de voertaal?</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {LANGUAGES.map((lang) => (
            <button
              key={lang.id}
              onClick={() => updateData({ language: lang.id })}
              className={`p-3 rounded-lg border text-center transition-all flex flex-col items-center justify-center ${
                data.language === lang.id
                  ? 'border-[#154A48] bg-white text-[#154A48] font-medium'
                  : 'border-gray-200 hover:border-[#154A48]/30'
              }`}
            >
              <span className="text-sm">{lang.label}</span>
              <span className="text-[10px] opacity-60 uppercase tracking-tighter">{lang.sub}</span>
            </button>
          ))}
        </div>
      </div>

      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-4 text-left">3. Hoeveel deelnemers verwacht u?</h3>
        <div className="max-w-xs">
          <label className="block text-sm font-medium text-gray-700 mb-1 text-left">Aantal personen</label>
          <input
            type="number"
            min="1"
            value={data.pax}
            onChange={(e) => updateData({ pax: parseInt(e.target.value) || '' })}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#154A48] focus:border-[#154A48] outline-none"
            placeholder="Bijv. 12"
          />
        </div>
        {showInfoTip && (
          <div className="mt-3 flex gap-2 items-start text-left bg-blue-50 p-3 rounded-lg border border-blue-100">
            <SafeIcon name="Info" className="text-blue-600 shrink-0 mt-0.5" />
            <p className="text-xs text-blue-800">
              <strong>Groepstarief & Sociale Sector:</strong> Voor groepen groter dan 20 personen, meerdaagse trajecten of <strong>sociale instellingen</strong> hanteren we vaak aangepaste tarieven.
            </p>
          </div>
        )}
      </div>

      {/* Button with solid color #154A48, no gradient, no shadow */}
      <button
        onClick={onNext}
        disabled={!isValid}
        className="w-full bg-[#154A48] text-white py-4 rounded-lg font-bold hover:bg-[#0E3432] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        Volgende stap
      </button>
    </div>
  );
}